






/* Created- 29 - Mar - 2019 */
import { Component, Vue } from "vue-property-decorator";
@Component(
	{
		name: "ParticaColumnContainer"
	})
export default class ParticaColumnContainer extends Vue {
}
